import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MitraNetworkParameters } from '../../state/network-parameters.model.generated';
import { SimulationService } from '../../state/simulation.service';

@Component({
  selector: 'app-optical-closure-form',
  templateUrl: './optical-closure-form.component.html',
  styleUrls: ['./optical-closure-form.component.scss']
})
export class OpticalClosureFormComponent implements OnInit {

  @Input()
  parameters: MitraNetworkParameters;

  @Input()
  parentForm: FormGroup;

  appliedForm = this.formBuilder.array([]);
  specificationForm = this.formBuilder.array([]);

  step = 0;
  isHorizontalUnbalanced: boolean;
  hasUnbalanced: boolean;

  constructor(
    private formBuilder: FormBuilder,
    private simulationService: SimulationService
  ) { }

  ngOnInit(): void {
    this.isHorizontalUnbalanced = this.simulationService.isHorizontalUnbalanced(this.parameters);
    this.hasUnbalanced = this.simulationService.hasUnbalanced(this.parameters);

    this.parentForm.addControl('appliedForm', this.appliedForm);
    this.parentForm.addControl('specificationForm', this.specificationForm);
  }

}
